"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBinary = void 0;
function isBinary(content) {
    return content.includes(0);
}
exports.isBinary = isBinary;
//# sourceMappingURL=binary.js.map